import { useState } from "react";

import { useNavigate } from "react-router-dom";

import type { UserCourseExercise, UserCourseLibraryExercise } from "api/schemas/UserCourse";
import { StyledPageContainer } from "routes/library/components/styles";
import { ExerciseLibraryList } from "routes/patients/PatientProfile/components/UserCourse/components/ExerciseLibraryList";

export const Exercises: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <StyledPageContainer isError={!!error}>
      <ExerciseLibraryList
        multiSelect={false}
        initialSelectedIds={[]}
        setError={setError}
        onClick={(id: number, exercise?: UserCourseExercise | UserCourseLibraryExercise) => {
          navigate(`${id}`, { state: { exercise } });
        }}
        libraryListSettingsStorageKey="exercise_library_list_settings"
        persistLibraryListSettings
      />
    </StyledPageContainer>
  );
};
